import { dinero, Dinero } from 'dinero.js';
import { Currency } from 'dinero.js';

import { useDefaultCurrency } from '@/hooks/useDefaultCurrency';

/**
 * Converts a number price to a Dinero object using the default currency from Stripe
 * This utility should be used inside React components that have access to hooks
 * 
 * For use outside components, use priceToDineroWithCurrency instead
 */
export const usePriceToDinero = () => {
  const { currency } = useDefaultCurrency();
  
  return (price: number, scale: number = 2): Dinero<number> => {
    return dinero({
      amount: Math.round(price * (currency.base ** currency.exponent || 10 ** scale)),
      currency,
      scale,
    });
  };
};

/**
 * Converts a number price to a Dinero object with a specific currency
 * Use this when you already have the currency object
 */
export const priceToDineroWithCurrency = (
  price: number,
  currency: Currency<number>,
  scale: number = 2
): Dinero<number> => {
  return dinero({
    amount: Math.round(price * (currency.base ** currency.exponent || 10 ** scale)),
    currency,
    scale,
  });
};

